import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { GraduationCap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-2 pb-12 md:pt-4 md:pb-16 overflow-hidden bg-white" data-id="element-155">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-156">
        <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-gold/5 blur-3xl" data-id="element-157" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-3xl text-center" data-id="element-158">
        {/* Pill badge */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-5 py-2 mb-8 rounded-full border border-gold/40 bg-gold/5 text-navy font-semibold text-sm tracking-wider uppercase" data-id="element-159">
          <GraduationCap className="w-4 h-4 text-gold" data-id="element-160" />
          MegaPack Lectura Fluida
        </motion.div>

        {/* Two-tone headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-sans md:text-5xl font-extrabold text-navy mb-8 text-[20px]" data-id="element-161">
          La ayuda que tu hijo necesita para leer con fluidez,{' '}
          <span className="text-gold" data-id="element-162">lista desde hoy.</span>
        </motion.h1>

        {/* Big centered product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-8" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/15nmDg4KgxufQZmTYd47N1/Texto_del_parrafo_(6).webp" alt="MegaPack Lectura Fluida — Sistema Completo" width={672} height={672} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-2xl shadow-navy/10" data-id="element-164" />
        </motion.div>

        {/* Paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-slate-600 mb-8 max-w-2xl mx-auto text-[16px]" data-id="element-165">
          Para padres de niños de 6 a 10 años: métodos visuales y sesiones de 10
          minutos.{' '}
          <span className="font-bold text-navy" data-id="element-166">
            Sin improvisar ni pelear más.
          </span>
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-167">
          <Button variant="gold" size="lg" href="#pricing" className="w-full sm:w-auto shadow-xl shadow-gold/20 text-base tracking-wide" data-id="element-168">
            QUIERO ACCEDER YA
          </Button>
        </motion.div>
      </div>
    </section>;
}